export const ResponseStatus = {
    Success: 'success',
    Error: 'error',
}

export const VerificationType = {
    Email: 'email',
    Sms: 'sms',
}

export const ResponseCode = {
    Success: 200,
    Created: 201,

    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    Conflict: 409,
    TooManyRequests: 429,

    InternalServerError: 500,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
}

export const FORM_TEXT_FIELD_REGEXP = /^[a-zA-Zа-яА-ЯёЁ0-9 _.,'()\-]+$/u;

export const FORM_PHONE_REGEXP = /^(\+79|\+78|89|88)([0-9]{9})$/;

export const FORM_TEXT_COMMENT_FIELD_REGEXP = /^[a-zA-Zа-яА-ЯёЁ0-9 _.,'()!?@"\-\t\r\n]+$/u;
